{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ShapeIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ShapeIcon = React.forwardRef<SVGSVGElement, ShapeIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 158 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M46.1334 81.5231C40.3511 81.5231 34.6807 81.4698 29.0124 81.538C23.107 81.6094 17.203 81.8529 11.2975 81.9022C9.40462 81.9009 7.51658 81.7113 5.66129 81.3367C0.962363 80.4278 -0.372013 77.4018 2.18168 73.3053C3.9406 70.4806 5.89063 67.7636 7.87234 65.0843C18.579 50.6037 29.3514 36.1717 40.0353 21.674C43.1329 17.4697 46.0534 13.133 48.9654 8.79693C49.7995 7.49357 50.492 6.10548 51.0317 4.65618C52.7287 0.362918 56.5586 -0.677117 59.9911 2.39042C61.1972 3.53961 62.2996 4.79222 63.2855 6.13379C69.7361 14.3572 76.1718 22.5925 82.5932 30.8397C82.9971 31.3591 83.4642 31.8239 83.9977 32.4211C91.0419 27.6835 99.1036 24.6593 107.534 23.5918C124.813 21.3358 138.363 27.3203 147.816 41.9938C152.556 49.3507 155.894 57.2835 156.852 66.0919C158.354 79.9266 154.482 92.2065 145.103 102.323C131.803 116.67 115.006 124.114 95.3858 123.603C78.4402 123.162 65.2358 114.987 55.7773 101.051C51.9129 95.3591 48.4544 89.3792 46.6812 82.617C46.54 82.2333 46.3564 81.8665 46.1334 81.5231ZM56.8432 81.2355C57.7618 83.3668 58.4068 85.2489 59.3514 86.968C60.8578 89.8142 62.5199 92.5753 64.3305 95.2397C70.91 104.603 79.7359 110.84 91.2803 111.874C109.903 113.544 125.612 107.026 138.23 93.3511C142.851 88.2859 145.65 81.8327 146.185 75.0075C147.492 61.1397 142.35 49.6078 132.704 39.8761C129.381 36.5274 125.127 34.881 120.62 33.8572C113.593 32.2601 106.668 33.143 99.8261 34.9712C95.9701 35.8825 92.2829 37.3967 88.9025 39.4573C89.7631 40.7285 90.4888 41.8224 91.236 42.9014C96.9297 51.1257 102.5 59.4271 106.815 68.4803C107.814 70.4578 108.63 72.5224 109.252 74.6479C110.629 79.8117 108.001 82.6702 102.629 82.4631C88.4927 81.9178 74.3484 81.5036 60.2068 81.0576C59.2315 81.0219 58.2504 81.1556 56.8432 81.2355ZM98.3681 74.0636C86.113 51.0815 69.9811 32.1186 53.9756 12.6519C41.1173 33.9039 26.0219 53.396 11.3303 74.1908C40.6411 73.241 69.1316 72.4522 98.3655 74.0636H98.3681Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="157" height="124" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

ShapeIcon.displayName = 'ShapeIcon'
